import { clsx } from "clsx";

export default function IconArrowRight({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7187 7.57227L17.2813 9.00976L24.0625 15.791H4V17.791H24.0625L17.2813 24.5723L18.7187 26.0098L27.2188 17.5098L27.9062 16.791L27.2188 16.0723L18.7187 7.57227Z"
        fill="currentColor"
      />
    </svg>
  );
}
